<template>
  <div class="message-block">
    <div class="error-message" :class="[align]" role="alert">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: {
    align: {
      required: false,
      type: String,
      default: 'left',
    },
  },
};
</script>

<style scoped>
.error-message {
  margin-bottom: 2rem;
  font-size: 1.6rem;
  font-weight: 500;
  color: #d93416;
}

.left {
  text-align: left;
}

.right {
  text-align: right;
}

.center {
  text-align: center;
}
</style>
